<script lang="ts">
  import clsx from 'clsx'
  import translationsStore from '../../stores/translations.svelte'

  type Props = {
    class?: string
  }

  let { class: className = '' }: Props = $props()
</script>

<div
  class={clsx(
    'animate-spin block w-12 h-12 border-4 border-current border-t-transparent rounded-full text-white',
    className,
  )}
  role="status"
  aria-label={translationsStore.state.loading}
>
  <span class="sr-only">{translationsStore.state.loading}...</span>
</div>
